export default {
  PROFILE_DIRECTOR: 1,
  PROFILE_INVESTIGADOR: 2,
  PROFILE_OTROS: 3
};
